import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, Col, Container, InputGroup, InputGroupAddon, Row } from 'reactstrap';
import {
  withRouter
} from 'react-router-dom'

import "./Franchise.css";

class FrPage500 extends Component {
  gotoLogin = () => {
    this.props.history.push("/fr/login");
  }
  render() {
    return (
      <div className="frErrorPage">
        <div className="frErrorPageLogo">
          <img src="/assets/img/nav/nav_logo.svg" alt="유통기한 언제지" />
        </div>
        <div className="frErrorCon">
          <img src="/assets/img/error/img_500.png" alt="500 Error Page" />
          <div className="frErrorTitle">잠시 후 다시 확인해주세요!</div>
          <div className="frErrorDesc">
            서버 접속이 원활하지 않습니다.<br />
            문제가 계속되면 아래 채널톡으로 문의해 주세요.
          </div>
          <Button onClick={this.gotoLogin}>로그인 홈으로 가기</Button>
          <div className="frErrorChat">
            <a href="https://dd73q.channel.io" target="_blank" className="channelTalk" rel="noopener noreferrer">문제가 있으신가요?</a>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(FrPage500);